import { itemProcessor } from "../plugins/itemProcessor";

export function startup_registerProcessUnprocessedItems() {
  itemProcessor.startProcessUnprocessedItemsInterval();
}
